import React, { useEffect, useState, useRef, useContext } from "react";
import styled, { CSSObject } from "styled-components";
import { IContent, IHeader } from "../../types";
import Select from "react-select";
import Header from "../../components/Header";
import { toast } from "react-toastify";
import { FirstContainer } from "../landing/Elements";
import { GlobalContext } from "../../context/globalContext";
import Flames from "../../components/flame/flame";
import Logo from "../landing/Logo";

interface IChosens {
  token_id: number;
  token_uri: string;
}

interface IMint {
  count: number;
}

const MintContainer = styled.section`

.flameDiv{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 200px;
  svg{
  }
}
.snowflake {
  color: #fff;
  font-size: 1em;
  font-family: Arial;
  text-shadow: 0 0 1px #000;
}
@-webkit-keyframes snowflakes-fall{0%{top:-10%}100%{top:100%}}@-webkit-keyframes snowflakes-shake{0%{-webkit-transform:translateX(0px);transform:translateX(0px)}50%{-webkit-transform:translateX(80px);transform:translateX(80px)}100%{-webkit-transform:translateX(0px);transform:translateX(0px)}}@keyframes snowflakes-fall{0%{top:-10%}100%{top:100%}}@keyframes snowflakes-shake{0%{transform:translateX(0px)}50%{transform:translateX(80px)}100%{transform:translateX(0px)}}.snowflake{position:fixed;top:-10%;z-index:9999;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default;-webkit-animation-name:snowflakes-fall,snowflakes-shake;-webkit-animation-duration:10s,3s;-webkit-animation-timing-function:linear,ease-in-out;-webkit-animation-iteration-count:infinite,infinite;-webkit-animation-play-state:running,running;animation-name:snowflakes-fall,snowflakes-shake;animation-duration:10s,3s;animation-timing-function:linear,ease-in-out;animation-iteration-count:infinite,infinite;animation-play-state:running,running}.snowflake:nth-of-type(0){left:1%;-webkit-animation-delay:0s,0s;animation-delay:0s,0s}.snowflake:nth-of-type(1){left:10%;-webkit-animation-delay:1s,1s;animation-delay:1s,1s}.snowflake:nth-of-type(2){left:20%;-webkit-animation-delay:6s,.5s;animation-delay:6s,.5s}.snowflake:nth-of-type(3){left:30%;-webkit-animation-delay:4s,2s;animation-delay:4s,2s}.snowflake:nth-of-type(4){left:40%;-webkit-animation-delay:2s,2s;animation-delay:2s,2s}.snowflake:nth-of-type(5){left:50%;-webkit-animation-delay:8s,3s;animation-delay:8s,3s}.snowflake:nth-of-type(6){left:60%;-webkit-animation-delay:6s,2s;animation-delay:6s,2s}.snowflake:nth-of-type(7){left:70%;-webkit-animation-delay:2.5s,1s;animation-delay:2.5s,1s}.snowflake:nth-of-type(8){left:80%;-webkit-animation-delay:1s,0s;animation-delay:1s,0s}.snowflake:nth-of-type(9){left:90%;-webkit-animation-delay:3s,1.5s;animation-delay:3s,1.5s}
  .headerClass {
    position: fixed;
    margin-top: -3rem;
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
  }
  .grandContainer {
    height: 100%;
    display: flex;
    padding: 2rem 0;
    padding-bottom: 12rem;
    flex-direction: column;
    align-items: center;
    max-width: 1400px;
    margin: 0 auto;
    h1,
    span {
      letter-spacing: 0.1rem;
      font-size: 1.2rem;
      font-family: "RocknRoll One";
      letter-spacing: 0.2rem;
      font-weight: 200;
      color: white;
    }
    .statContainerDiv {
      margin-top: 4rem;
      display: flex;
      border-radius: 0.6rem;
      justify-content: center;
      align-items: center;
      width: 25rem;
      height: 3rem;
      cursor: pointer;
      h1 {
        color: white;
      }
    }
    .gifContainer {
      z-index: 5;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .gif {
        margin-top: 2rem;
        height: 500px;
        width: 500px;
        z-index: 20;
        object-fit: contain;
        border-radius: 0px 20px;
        -webkit-transition: 0.15s;
        -moz-transition: 0.15s;
        -ms-transition: 0.15s;
        -o-transition: 0.15s;
        transition: 0.15s;
        border: 1.5rem solid #dfdbdb;
      }
      .priceComponent {
        display: flex;
        margin: 2rem;
        h1 {
          font-size: 3rem;
        }
      }
    }
    .buttonContainer {
      margin-top: 3rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 50vw;
    }
    .quantityContainer {
      display: flex;
      .selectContainer {
        width: 15rem;
        height: 5rem;
      }
    }
    .buttonSection {
      margin-top: 1rem;
      width: 15rem;
      height: 5rem;
      border-width: 0px;
      border-radius: 15px;
      background: #ffcb0f;
      -webkit-transition: 0.1s;
      -moz-transition: 0.1s;
      -ms-transition: 0.1s;
      -o-transition: 0.1s;
      transition: 0.1s;
    }
    }
    .buttonSection:hover {
      background: rgb(128,130,207);
      transition: transform linear 250ms;
      transform: translateY(-20px);
      transform: scale(0.9);
    }
  }
  @media screen and (max-width: 850px) {
    .grandContainer {
      flex-direction: column;
      padding: 5rem 0;
    }

    .quantityContainer {
      position: relative;
      z-index: 30;
      .selectContainer {
      }
    }
  }
  @media screen and (max-width: 500px) {
    .logoDiv{
      position: absolute;
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      margin-top: 2em;
    }
    .headerClass {
    position: fixed;
    top: 0rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
  }
    .grandContainer {
      .statContainerDiv {
      margin-top: 2rem;
      width: 16rem;
      height: 3rem;
      h1 {
        font-size: 0.8rem;
        text-align: center;
      }
    }
      .gifContainer {
        .gif {
          height: 300px;
          width: 300px;
        }
      }
    }
  }
`;
interface Animal {
  label: string;
  value: number;
}

const items: Animal[] = [
  { label: "1 Rock n Bones", value: 1 },
  { label: "2 Rock n Bones", value: 2 },
  { label: "3 Rock n Bones", value: 3 },
  { label: "4 Rock n Bones", value: 4 },
  { label: "5 Rock n Bones", value: 5 },
  { label: "10 Rock n Bones", value: 10 },
  { label: "25 Rock n Bones", value: 25 },
  { label: "100 Rock n Bones", value: 100 },
  { label: "250 Rock n Bones", value: 250 },
];

interface IMinted {
  minted: boolean | number;
}

export const Mint: React.FC = () => {
  const { handleMintNowCount, mintLeft } = useContext(GlobalContext);

  const [chosenValue, setChosenValue] = useState<number>(1);
  // const [mintNow, setMintNow] = useState<IMint>({ count: 1 });
  const data: IContent = require("../../data/json/text.json");
  // const [mintLeft, setMintLeft] = useState<IMinted>({ minted: false });

  useEffect(() => {}, [mintLeft.minted]);

  useEffect(() => {
    toast(`${chosenValue} item ready for mint!`);
  }, [chosenValue]);

  const customStyles = {
    control: (styles: CSSObject) => {
      return {
        ...styles,
        display: "flex",
        height: "5rem",
        borderRadius: "15px",
        borderColor: "",
        background: "#dfdbdb",
        fontFamily: "RocknRoll One",
      };
    },
    option: (
      styles: CSSObject,
      { data, isDisabled, isFocused, isSelected, isActive }: any
    ) => {
      return {
        ...styles,
        background: isFocused ? "#dfdbdb" : "",
      };
    },
    menu: (styles: CSSObject) => {
      return {
        ...styles,
        fontFamily: "RocknRoll One",
      };
    },
    placeholder: (styles: CSSObject) => ({
      ...styles,
      color: "black",
      fontSize: "1.25rem",
    }),
    input: (styles: CSSObject) => ({
      ...styles,
      fontFamily: `RocknRoll One`,
      "& input": {
        font: "inherit",
        alignSelf: "center",
      },
    }),
  };

  const handleSelect = (option: any) => {
    if (option) {
      setChosenValue(option.value);
    }
  };
  return (
    <MintContainer>
      <div className="snowflakes" aria-hidden="true">
        <div className="snowflake">❅</div>
        <div className="snowflake">❅</div>
        <div className="snowflake">❆</div>
        <div className="snowflake">❄</div>
        <div className="snowflake">❅</div>
        <div className="snowflake">❆</div>
        <div className="snowflake">❄</div>
        <div className="snowflake">❅</div>
        <div className="snowflake">❆</div>
        <div className="snowflake">❄</div>
      </div>

      <FirstContainer>
        <Header minting={true} />
      </FirstContainer>

      <div className="logoDiv">
        <Logo />
      </div>

      <div className="grandContainer">
        <div className="gifContainer">
          <div className={"statContainerDiv"}>
            {mintLeft.minted ? (
              <h1>Supply 6006 / {mintLeft.minted}</h1>
            ) : (
              <h1 style={{ cursor: "default" }}>
                Connect Wallet to See Supply
              </h1>
            )}
          </div>
          <img
            className="gif"
            src={require("./../../data/png/emoji.gif").default}
            alt="gif"
          />
          <div className="priceComponent">
            <h1>{chosenValue * 0.015} ETH</h1>
          </div>
        </div>

        <div className={"quantityContainer"}>
          <div className="selectContainer">
            <Select
              menuPlacement="bottom"
              onChange={handleSelect}
              options={items}
              // styles={customStyles}
              placeholder="Number of mint!"
            />
          </div>
        </div>

        <button
          className="buttonSection"
          onClick={() => {
            toast("You are minting now!");
            handleMintNowCount(chosenValue);
          }}
        >
          <span>Mint Now</span>
        </button>
      </div>

      <div className={"flameDiv"}>
        <Flames />
      </div>
    </MintContainer>
  );
};
